import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useLock } from '../../context/LockContext';
import { useTheme } from '../../context/ThemeContext';
import { useSidebar } from '../../context/SidebarContext';
import { useVertical } from '../../context/VerticalContext';
import UserMenu from '../UserMenu';
import Icon from '../Icon';
import LanguageSelector from '../LanguageSelector';
import HelpCenterMenu from '../help/HelpCenterMenu';
import './Header.css';

function Header() {
  const { t } = useTranslation();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const { user } = useAuth();
  const { hasPin, lock } = useLock();
  const { preference, cyclePreference } = useTheme();

  const themeIcon = { light: 'light_mode', dark: 'dark_mode', auto: 'brightness_auto' }[
    preference
  ];
  const themeLabel = t(`theme.${preference}`);
  const { isMobileMenuOpen, toggleMobileMenu } = useSidebar();
  // Consultame (NER-4044): marca dinámica según la vertical de producto.
  const { isMedical } = useVertical();

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const closeUserMenu = () => {
    setIsUserMenuOpen(false);
  };

  const handleLock = () => {
    lock();
  };

  return (
    <header className="header-new">
      <div className="header-left">
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label={
            isMobileMenuOpen
              ? t('common.closeMenu', 'Cerrar menú')
              : t('common.openMenu', 'Abrir menú')
          }
        >
          <Icon name={isMobileMenuOpen ? 'close' : 'menu'} />
        </button>
        <div className="header-logo">
          <Icon
            name={isMedical ? 'medical_services' : 'event_available'}
            className="logo-icon"
          />
          <span className="logo-text">{isMedical ? 'Consultame' : 'Citame'}</span>
        </div>
      </div>

      <div className="header-right">
        <LanguageSelector />

        <HelpCenterMenu />

        <button
          type="button"
          className="header-icon-btn"
          onClick={cyclePreference}
          aria-label={`${t('theme.title')}: ${themeLabel}`}
          title={`${t('theme.title')}: ${themeLabel}`}
        >
          <Icon name={themeIcon} size="small" />
        </button>

        {hasPin && (
          <button
            type="button"
            className="header-icon-btn"
            onClick={handleLock}
            aria-label="Lock screen"
            title={t('lock.lock')}
          >
            <Icon name="lock" size="small" />
          </button>
        )}

        <div className="user-menu-container">
          <button
            type="button"
            className="user-menu-btn"
            onClick={toggleUserMenu}
            aria-label="User menu"
          >
            <div className="header-user-avatar">
              {user?.attributes?.charAt(0).toUpperCase() ||
                user?.username?.charAt(0).toUpperCase() || <Icon name="person" size="small" />}
            </div>
            <span className="user-name">{user?.attributes || user?.username}</span>
            <Icon
              name="arrow_drop_down"
              size="small"
              className={`dropdown-arrow ${isUserMenuOpen ? 'open' : ''}`}
            />
          </button>

          {isUserMenuOpen && <UserMenu onClose={closeUserMenu} />}
        </div>
      </div>

      {/* Overlay to close menus */}
      {isUserMenuOpen && (
        <div
          className="menu-overlay"
          onClick={() => {
            closeUserMenu();
          }}
        ></div>
      )}
    </header>
  );
}

export default Header;
